/**
  @module @ember-data/store
*/

/**
 * Maps public interfaces to internal class implementations
 *
 * @internal
 */

/**
 * Casts a public interface to the matching internal class implementation
 *
 * @internal
 */
export function upgradeForInternal(external) {
  return external;
}